import script from "./AssessmentGender.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentGender.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentGender.vue?vue&type=style&index=0&id=709d4847&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-709d4847"]])

export default __exports__